module.exports = __webpack_public_path__ + "static/media/Nalik_2026_PDF.a23728c0.pdf";